import { render, staticRenderFns } from "./PersonaContainer.vue?vue&type=template&id=2cebc906&scoped=true&"
import script from "./PersonaContainer.vue?vue&type=script&lang=js&"
export * from "./PersonaContainer.vue?vue&type=script&lang=js&"
import style0 from "./PersonaContainer.vue?vue&type=style&index=0&id=2cebc906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebc906",
  null
  
)

export default component.exports